export default {
  priv: 'pr_manage',
  overviewTitle: 'Gebruikers',
  detailTitle: 'Gebruiker',
  deleteTitle: 'deze gebruiker',
  url: '/manage/users',
  apiUrl: '/users/',
  sortBy: ['name'],
  sortDesc: [false],
  deletable: false,
  editable: true,
  filterName: 'users',
  quickFilter: {
    text: 'Zoek op naam',
    value: 'name',
    type: 'text'
  },
  newRecord: {
    is_active: true
  },
  tableFields: [
    {
      text: 'Naam',
      value: 'full_name',
      link: '/manage/users/{id}',
      width: '15%'
    },
    {
      text: 'Gebruikersnaam',
      value: 'username',
      width: '15%'
    },
    {
      text: 'Rol',
      value: 'userrole_name_nl',
      width: '7.5%'
    },
    {
      text: 'Email',
      value: 'email',
      width: '15%'
    },
    {
      text: 'Actief',
      value: 'is_active',
      type: 'boolean',
      width: '7.5%'
    },
    {
      text: 'Admin',
      value: 'is_superuser',
      type: 'boolean',
      width: '7.5%'
    }
  ]
};
